import { filter, propEq } from 'ramda';
import { createSelector } from 'reselect';
import { dotPathOr } from 'ramda-extension';

export const selectAllToasts = dotPathOr([], 'toasts.queue');

// One memoized selector per context. Creating a new selector on every call
// returned a new array on every store update, which re-rendered App (and every
// useLastToast user) on each dispatch.
const selectorsByContext = new Map();

export const selectToastsByContext = (ctx) => {
  if (!selectorsByContext.has(ctx)) {
    selectorsByContext.set(
      ctx,
      createSelector(selectAllToasts, (toasts) =>
        filter(propEq('context', ctx), toasts)
      )
    );
  }
  return selectorsByContext.get(ctx);
};
